import { formatDollars } from '~/utils/formatNumber';
import targetITCPercent from './targetITCPercent';
import { InvestorBidStatus, PricingType } from '~/constants';
import { Project } from '~/types/project';

export default function targetITC(project: Project, projectCosts: any, permissions: any) {
  //projectCosts can be an array for sell side fees
  if (Array.isArray(projectCosts) && projectCosts?.length > 0) {
    //match individual projectCost object to the current bid parentProjectId
    const projectCost = projectCosts?.find((row: any) => row?.bid?.parentProjectId === project?.id);
    projectCosts = projectCost;
  } 

  let adderStr = '';
  project?.itcAdders?.forEach((adder: any, i: number) => {
    if (i > 0) {
      adderStr += ', ';
    }
    adderStr += adder.label;
  });

  const itcPlusAddersString = `(${targetITCPercent(project)} ITC${adderStr ? ` — ${adderStr}` : ''})`;

  let hasTargetItc: boolean = true;
  if (projectCosts?.bid?.bidStatus === InvestorBidStatus.REJECTED || projectCosts?.bid?.bidStatus === InvestorBidStatus.DECLINED) {
    hasTargetItc = false;
  }
  if (permissions.hasProjectInvestorAccess && !permissions.isAdmin) {
    if (project?.pricingType === PricingType.ACQUISITION && !projectCosts?.bid) {
      hasTargetItc = false;
    }
  }
  if (permissions.hasProjectDeveloperAccess) {
    if (
      project?.pricingType === PricingType.ACQUISITION
      && (!projectCosts?.bid || projectCosts?.bid?.bidStatus === InvestorBidStatus.PENDING)
    ) {
      hasTargetItc = false;
    }  
  }

  if (projectCosts?.expectedItcCost && hasTargetItc) {
    // Show $ amount of how much of the project value the ITC percent will cover
    return `${formatDollars(projectCosts?.expectedItcCost)} ${itcPlusAddersString}`;
  } else {
    // Show ITC percent without a $ amount since the $ value has not yet been determined
    return `TBD pending bids ${itcPlusAddersString}`;
  }
}